import { useContext } from "react";

import { ErrorContext } from "../contexts/ErrorContext";

import type { ErrorContextValue } from "../types";

export const useError = (): ErrorContextValue => {
  const context = useContext(ErrorContext);
  if (context === undefined) {
    throw new Error("useError must be used within an ErrorProvider");
  }
  return context;
};
